module.exports = __webpack_public_path__ + "img/65_2.0861d7a5.png";